"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const loading_spinner_1 = require("./loading-spinner");
const LoadingContent = ({ withText, size, variant = "primary", loadingText }) => {
    const theme = (0, material_1.useTheme)();
    const spinnerSize = (0, react_1.useMemo)(() => {
        switch (size) {
            case "large":
                return 20;
            case "medium":
                return 16;
            case "xs":
                return 12;
            default:
                return 16;
        }
    }, [size]);
    const spinnerColor = (0, react_1.useMemo)(() => {
        switch (variant) {
            case "tertiary":
            case "tertiary_quiet":
                return theme.palette.gray[50];
            default:
                return "currentColor";
        }
    }, [theme, variant]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
            display: "flex",
            alignItems: "center",
        }, children: [(0, jsx_runtime_1.jsx)(loading_spinner_1.LoadingSpinner, { color: spinnerColor, size: spinnerSize, thickness: 4 }), withText && ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", sx: {
                    ml: "12px",
                    ...(size === "xs" && { ml: "8px" }),
                }, children: loadingText ?? "Loading..." }))] }));
};
const Button = ({ children, loading, loadingText, loadingWithoutText, sx = [], ...props }, ref) => ((0, jsx_runtime_1.jsx)(material_1.Button, { sx: [
        {
            pointerEvents: loading ? "none" : "auto",
            position: "relative",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
    ], ...props, ref: ref, children: loading ? ((0, jsx_runtime_1.jsx)(LoadingContent, { loadingText: loadingText, withText: !loadingWithoutText, size: props.size, variant: props.variant })) : (children) }));
const ButtonForwardRef = (0, react_1.forwardRef)(Button);
exports.Button = ButtonForwardRef;
